/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mascot_Chat_Operator_TagInputs */

const tr_mascot_chat_operator_tag = /** @type {(inputs: Mascot_Chat_Operator_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canlı destek`)
};

const en_mascot_chat_operator_tag = /** @type {(inputs: Mascot_Chat_Operator_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live support`)
};

const de_mascot_chat_operator_tag = /** @type {(inputs: Mascot_Chat_Operator_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Support`)
};

const ru_mascot_chat_operator_tag = /** @type {(inputs: Mascot_Chat_Operator_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Живая поддержка`)
};

/**
* | output |
* | --- |
* | "Live support" |
*
* @param {Mascot_Chat_Operator_TagInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mascot_chat_operator_tag = /** @type {((inputs?: Mascot_Chat_Operator_TagInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mascot_Chat_Operator_TagInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mascot_chat_operator_tag(inputs)
	if (locale === "de") return de_mascot_chat_operator_tag(inputs)
	if (locale === "ru") return ru_mascot_chat_operator_tag(inputs)
	return tr_mascot_chat_operator_tag(inputs)
});